module.exports = __webpack_public_path__ + "static/media/menucancle_icon.dbda4c41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/menucancle_icon.svg
// module id = 1634
// module chunks = 0